import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ISupport } from "../../models/BaseModel";
import { Controller, useForm, useWatch } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { FileUpload } from "primereact/fileupload";
import { JVInput } from "../../shared/JVInput";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

interface Iprops {
    singleData: any,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean,
    isDisable?: boolean,
}

const schema = yup.object({
    application_Id: yup.number().required("Application required").typeError("Application required"),
    priority: yup.string().required("Priority required").typeError("Priority required"),
    impact: yup.string().required("Impact required").typeError("Impact required"),
    assign_group_Id: yup.number().required("Assign group required").typeError("Assign group required"),
    subject: yup.string().required("Subject required"),
});

export const priorityOptions = [
    { label: "Low", value: "Low" },
    { label: "Medium", value: "Medium" },
    { label: "High", value: "High" },
    { label: "Critical", value: "Critical" },
];

export const impactOptions = [
    { label: "Low", value: "Low" },
    { label: "Medium", value: "Medium" },
    { label: "High", value: "High" },
];

export const Form = (props: Iprops) => {
    const [submitting, setSubmitting] = useState(false);
    const [resumeFile, setResumeFile] = useState<File | null>(null);
    const [image, setImage] = useState(false);
    const [applicationGroup, setApplicationGroup] = useState<any[]>([]);
    const [supportStatus, setSupportStatus] = useState<any[]>([]);
    const [assignGroups, setAssignGroups] = useState<any[]>([]);
    const [description, setDescription] = useState("");
    const [showRemark, setShowRemark] = useState(false);
    const [originalStatus, setOriginalStatus] = useState<number | null>(null);

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue, getValues } = useForm<ISupport>({
        resolver: yupResolver(schema),
        defaultValues: {
            priority: "",
            impact: "",
            subject: "",
        },
        shouldFocusError: false,
    });

    const watchedValues = watch();

    const [originalData, setOriginalData] = useState<any>(null);

    useEffect(() => {
        if (props.singleData) {
            const mappedData = {
                application_Id: props.singleData.application_Group_Id ?? null,
                priority: props.singleData.priority ?? "",
                impact: props.singleData.impact ?? "",
                assign_group_Id: props.singleData.assigned_Group_Id ?? null,
                subject: props.singleData.subject ?? "",
                status: props.singleData.status ?? null
            };

            reset(mappedData);
            setOriginalData(mappedData);
            setDescription(props.singleData.description || "");
            setOriginalStatus(props.singleData.status ?? null);

            setImage(false);
            setResumeFile(null);
        } else {
            reset();
            setOriginalData(null);
            setDescription("");
            setImage(false);
            setResumeFile(null);
            setOriginalStatus(null);

        }
    }, [props.singleData, reset]);


    // const getChangedFields = () => {
    //     if (!originalData) return [];
    //     let changed: Array<{ field_Name: string; old_Value: any; new_Value: any }> = [];
    //     Object.keys(watchedValues).forEach(key => {
    //         if (watchedValues[key] !== originalData[key]) {
    //             changed.push({
    //                 field_Name: key,
    //                 old_Value: originalData[key] ?? "",
    //                 new_Value: watchedValues[key] ?? "",
    //             });
    //         }
    //     });

    //     if (description !== (props.singleData?.description || "")) {
    //         changed.push({
    //             field_Name: "desc",
    //             old_Value: props.singleData?.description || "",
    //             new_Value: description || "",
    //         });
    //     }

    //     return changed;
    // };


    const getChangedFields = () => {
        if (!originalData) return [];

        let changed: Array<{ field_Name: keyof ISupport | string; old_Value: any; new_Value: any }> = [];

        const keys = Object.keys(watchedValues) as Array<keyof ISupport>;

        const ignoreFields = ["status", "remark"];

        keys.forEach(key => {
            if (ignoreFields.includes(key as string)) return;

            if (watchedValues[key] !== originalData?.[key]) {
                changed.push({
                    field_Name: key,
                    old_Value: originalData?.[key] ?? "",
                    new_Value: watchedValues[key] ?? "",
                });
            }
        });
        if (description !== (props.singleData?.description || "")) {
            changed.push({
                field_Name: "desc",
                old_Value: props.singleData?.description || "",
                new_Value: description || "",
            });
        }

        return changed;
    };



    // const saveToDB = async (data: any) => {
    //     try {
    //         setSubmitting(true);
    //         const method = props.isDisable ? "PUT" : "POST";
    //         const url = props.isDisable ? `Support/updateTicket` : `Support/CreateTicket`;
    //         const message = props.isDisable ? "Updated Successfully" : "Added Successfully";
    //         const changes = props.isDisable ? getChangedFields() : [];

    //         if (props.isDisable && changes.length === 0) {
    //             props.toast.current?.show({ severity: "error", summary: "No Changes", detail: "No changes found to update.", life: 3000 });
    //             return;
    //         }
    //         const body = {
    //             ticket_Id: props.singleData?.ticket_Number,
    //             application_Id: data.application_Id,
    //             priority: data.priority,
    //             impact: data.impact,
    //             assign_group_Id: data.assign_group_Id,
    //             subject: data.subject,
    //             desc: description || "",
    //             Changes: changes,
    //         };

    //         if (!props.isDisable) {
    //             const formData = new FormData();
    //             formData.append("application_Id", data.application_Id.toString());
    //             formData.append("priority", data.priority);
    //             formData.append("impact", data.impact);
    //             formData.append("assign_group_Id", data.assign_group_Id.toString());
    //             formData.append("subject", data.subject);
    //             formData.append("desc", description || "");
    //             if (resumeFile) formData.append("screenshot", resumeFile);

    //             const response = await Fetch(url, method, formData, null, props.toast);
    //             if (response) {
    //                 props.toast.current?.show({ severity: "success", summary: "Success", detail: message, life: 3000 });
    //                 reset();
    //                 props.reloadData();
    //                 setImage(false);
    //                 setResumeFile(null);
    //                 onHide();
    //             }
    //         } else {
    //             const response = await Fetch(url, method, body, null, props.toast);
    //             if (response) {
    //                 props.toast.current?.show({ severity: "success", summary: "Success", detail: message, life: 3000 });
    //                 reset();
    //                 props.reloadData();
    //                 setImage(false);
    //                 setResumeFile(null);
    //                 onHide();
    //             }
    //         }
    //     } catch (error) {
    //         props.toast.current?.show({ severity: "error", summary: "Error", detail: "Failed to save ticket", life: 3000 });
    //     } finally {
    //         setSubmitting(false);
    //     }
    // };

    const saveToDB = async (data: any) => {
        try {
            setSubmitting(true);
            const method = props.isDisable ? "PUT" : "POST";
            const url = props.isDisable ? `Support/updateTicket` : `Support/CreateTicket`;
            const message = props.isDisable ? "Updated Successfully" : "Added Successfully";
            const changes = props.isDisable ? getChangedFields() : [];
            console.log(changes)
            if (props.isDisable && changes.length === 0) {
                props.toast.current?.show({
                    severity: "error", summary: "", detail: "No changes found to update.", life: 3000
                });
                return;
            }

            const body = {
                ticket_Id: props.singleData?.ticket_Number,
                application_Id: data.application_Id,
                priority: data.priority,
                impact: data.impact,
                assign_group_Id: data.assign_group_Id,
                subject: data.subject,
                desc: description || "",
                Changes: changes,
            };
            if (!props.isDisable) {
                const formData = new FormData();
                formData.append("application_Id", data.application_Id.toString());
                formData.append("priority", data.priority);
                formData.append("impact", data.impact);
                formData.append("assign_group_Id", data.assign_group_Id.toString());
                formData.append("subject", data.subject);
                formData.append("desc", description || "");
                if (resumeFile) formData.append("screenshot", resumeFile);

                const response = await Fetch(url, method, formData, null, props.toast);
                if (response) {
                    props.toast.current?.show({ severity: "success", summary: "Success", detail: message, life: 3000 });
                    reset();
                    props.reloadData();
                    setImage(false);
                    setResumeFile(null);
                    onHide();
                }
            }
            else {
                const response = await Fetch(url, method, body, null, props.toast);
                if (response) {
                    props.toast.current?.show({ severity: "success", summary: "Success", detail: message, life: 3000 });
                    reset();
                    props.reloadData();
                    setImage(false);
                    setResumeFile(null);
                    onHide();
                }
            }
        } catch (error) {
            props.toast.current?.show({ severity: "error", summary: "Error", detail: "Failed to save ticket", life: 3000 });
        } finally {
            setSubmitting(false);
        }
    };

    const onHide = () => {
        props.hideDialog();
        reset();
        setDescription("");
        setImage(false);
        setResumeFile(null);
        setOriginalData(null);
    };

    const onUpload = (event: any) => {
        const file = event.files[0];
        if (!file) return;
        const validTypes = ["image/png", "image/jpeg", "image/jpg"];
        if (!validTypes.includes(file.type)) {
            props.toast.current.show({ severity: 'error', detail: "Please choose an image file (png, jpg, jpeg).", life: 3000 });
            event.options.clear();
            return;
        }
        if (file.size > 2 * 1024 * 1024) {
            props.toast.current.show({ severity: 'error', detail: "Image file should be less than 2 MB.", life: 3000 });
            event.options.clear();
            return;
        }

        setResumeFile(file);
        setImage(true);
        event.options.clear();
        props.toast.current.show({ severity: 'success', summary: 'Success', detail: "Screenshot saved", life: 3000 });
    };

    const loadApplicationGroup = async () => {
        const response = await Fetch("Support/ApplicationGroup", "GET", null, null, props.toast);
        if (response) {
            setApplicationGroup(await response.json());
        }
    };

    const loadAssignGroups = async () => {
        const response = await Fetch("Support/AssignGroup", "GET", null, null, props.toast);
        if (response) {
            setAssignGroups(await response.json());
        }
    };
    const loadStatus = async () => {
        const response = await Fetch("Support/supportStatus", "GET", null, null, props.toast);
        if (response) {
            const allStatus = await response.json();

            // Filter Closed & Reopen
            let filteredStatus = allStatus.filter((s: any) =>
                s.status === "Closed" || s.status === "Reopen"
            );

            const currentStatus = props.singleData?.status;

            filteredStatus = filteredStatus.map((s: any) => {
                if (currentStatus === 5) {
                    return {
                        ...s,
                        disabled: s.status === 5,
                    };
                }
                if (currentStatus === 6) {
                    return {
                        ...s,
                        disabled: s.status === 6,
                    };
                }
                return s;
            });

            setSupportStatus(filteredStatus);
        }
    };




    useEffect(() => {
        loadApplicationGroup();
        loadAssignGroups();
        loadStatus();
    }, []);

    const onSubmit = (data: any) => {
        if (!description || description.trim() === "") {
            props.toast.current?.show({ severity: 'error', detail: "Description field is required", life: 3000 });
            return;
        }
        saveToDB(data);
    };

    const watchedStatus = watch("status");

    const statusChanged = originalStatus !== null && watchedStatus !== originalStatus;



    useEffect(() => {
        if (props.isDisable && watchedStatus) {
            setShowRemark(true);
        } else {
            setShowRemark(false);
            setValue("remark", "");
        }
    }, [watchedStatus, props.isDisable, setValue]);



    const updateTicketStatus = async () => {
        const status = getValues("status");
        const remark = getValues("remark");

        const ticketId = props.singleData?.ticket_Number;

        if (!status) {
            props.toast.current?.show({ severity: "error", summary: "Error", detail: "Please select a status.", life: 3000, });
            return;
        }
        if (showRemark && (!remark || remark.trim() === "")) {
            props.toast.current?.show({ severity: "error", summary: "Error", detail: "Please enter a remark.", life: 3000, });
            return;
        }

        try {
            setSubmitting(true);
            const body = { Ticket_Id: ticketId, Status: status, Remark: remark || "", };
            const response = await Fetch("Support/changeTicketStatus", "PUT", body, null, props.toast);
            if (response) {
                props.toast.current?.show({
                    severity: "success",
                    summary: "Success",
                    detail: "Status updated successfully.",
                    life: 3000,
                });
                props.reloadData();
                onHide();
            }
        } catch (error) {
            props.toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Failed to update status.",
                life: 3000,
            });
        } finally {
            setSubmitting(false);
        }
    };


    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '600px' }} header={props.isDisable ? "Update Support Ticket" : "Create Support Ticket"} modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <div className="field col-12 md:col-12 mt-0">
                    <JVDropdown disabled={props.isDisable} required column={1} label="Application" control={control} options={applicationGroup} optionLabel="application_Name" optionValue="support_Application_Id" name="application_Id" placeholder="Select Application" error={errors.application_Id?.message} />
                    <JVDropdown required column={1} label="Priority" control={control} options={priorityOptions} optionLabel="label" optionValue="value" name="priority" placeholder="Select Priority" error={errors.priority?.message} />
                    <JVDropdown required column={1} label="Impact" control={control} options={impactOptions} optionLabel="label" optionValue="value" name="impact" placeholder="Select Impact" error={errors.impact?.message} />
                    <JVDropdown disabled={props.isDisable} required column={1} label="Assign Group" control={control} options={assignGroups} optionLabel="assign_Group_Name" optionValue="assign_Group_Id" name="assign_group_Id" placeholder="Select Assign Group" error={errors.assign_group_Id?.message} />
                    {props.isDisable && <JVDropdown required column={1} label="Status" control={control} options={supportStatus} optionLabel="status" optionValue="status_Id" name="status" placeholder="Select Status"
                        optionDisabled={(opt) => {
                            const current = props.singleData?.status;
                            if (current === null || current === 1) {
                                return opt.status_Id !== 5;
                            }
                            if (current === 5) {
                                return opt.status_Id === 5;
                            }
                            if (current === 6) {
                                return opt.status_Id === 6;
                            }
                            return false;
                        }}
                    />

                    }
                    {props.isDisable && statusChanged && <JVInput column={1} label="Remark" control={control} name="remark" />}
                    {props.isDisable && statusChanged && <div className="col-12 flex justify-content-end mt-3">
                        <Button
                            label="Update Status"
                            className="p-button-rounded"
                            onClick={(e) => {
                                e.preventDefault();
                                updateTicketStatus();
                            }}
                            loading={submitting}
                            style={{ width: "140px" }}
                        />
                    </div>}
                    {!props.isDisable && (
                        <div className="card flex justify-content-center mt-3">
                            <FileUpload chooseLabel="Upload Screenshots" mode="basic" name="image" accept="image/*" customUpload uploadHandler={onUpload} auto />
                        </div>
                    )}
                    <JVInput required column={1} label="Subject" control={control} name="subject" error={errors.subject?.message} />
                    <div className="flex flex-column w-12 ml-3 mt-3">
                        <label htmlFor="">Description:<span style={{ color: 'red' }}>*</span></label>
                        <CKEditor editor={ClassicEditor} data={description} onChange={(event, editor) => setDescription(editor.getData())} />
                    </div>
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-4">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded" />
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200" />
                </div>
            </form>
        </Dialog>
    );
};
